export class GetPresignedUrlRequestDto {
  image: string;
  image_type: string;
  mime_type: string;

  constructor(image: string, image_type: string, mime_type: string) {
    this.image = image;
    this.image_type = image_type;
    this.mime_type = mime_type;
  }
}
